<template>
    <div
        class="notification-banner-wrapper g-container"
        :class="{
            'closing' : isClosing,
            'warning' : notificationType === 'warning',
            'success' : notificationType === 'success',
            'failed' : notificationType === 'failed'
        }"
    >
        <div class="content">
            <div class="icon">
                <img
                    :src="require(`@/assets/img/icon/${notificationType}-icon.png`)"
                    v-if="notificationType === 'success'"
                >
            </div>

            <div class="message">
                <div class="header">
                    <span>
                        {{ notificationType }}
                    </span>
                </div>

                <p v-html="notificationDesc" />
            </div>

            <div class="close">
                <span @click="close()">
                    &times;
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapFields } from 'vuex-map-fields'

export default {
	computed: {
        ...mapFields('modal', [
            'notificationType',
            'notificationDesc'
        ]),
	},

	data () {
		return {
			isClosing: false
		}
	},

	mounted () {
		setTimeout(() => this.autoClose(), 5000)
    },

	methods: {
		autoClose () {
			if (!this.isClosing) {
                this.isClosing = true
                
				setTimeout(() => {
                    this.$store.commit('modal/toggleNotification', { notificationName: '' })
                }, 1000)
			}
		},

		close () {
			this.autoClose()
		}
	}
}
</script>

<style lang="scss" scoped>
.notification-banner-wrapper {
    position: fixed;
    top: 60px;
    right: 0;
    left: 0;
    margin: 0 auto;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 10px;
    z-index: 999;
    pointer-events: none;

    .content {
        position: relative;
        display: flex;
        align-items: center;
        background: #fff;
        box-shadow: 0 0 24px rgba(0,0,0,0.15);
        border-radius: 5px;
        width: 465px;
        padding: 10px;
        pointer-events: all;

        @include fadeinright(0.5s,0s);

        .icon {
            padding: 0 5px;

            img {
                width: 24px;
                height: auto;
            }
        }

        .message {
            flex: 1 1 auto;
            padding: 0 20px;

            .header {
                span {
                    display: block;
                    text-align: left;
                    text-transform: capitalize;
                    font-size: 16px;
                    font-weight: 700;
                    color: #4A4C50;
                }
            }

            p {
                text-align: left;
                margin-top: 5px;
                font-size: 14px;
                font-style: italic;
                color: #979CAC;
            }
        }

        .close {
            padding: 10px;
            cursor: pointer;

            span {
                color: #979CAC;
                font-size: 24px;
            }
        }
    }

    &.success {
        .content {
            border-left: 10px solid #29C27C;
        }
    }

    &.warning {
        .content {
            border-left: 10px solid #F8C51B;
        }
    }

    &.failed {
        .content {
            border-left: 10px solid #f54b5e;
        }
    }

    &.closing {
        .content {
            @include fadeoutright(0.5s,0s);
        }
    }
}
</style>
